import { action } from 'mobx';

import { ConnectionAppManager, Variables } from 'core/index';

import { InitiativeArrayApp } from 'apps/initiative/app';
import { InitiativesQuery } from 'apps/initiative/gql/index';

import i18next from 'i18next';

export class InitiativeConnManager extends ConnectionAppManager {
  static ArrayApp = InitiativeArrayApp;
  constructor(parent, init, options) {
    super(parent, init, options);
    this.initialBatchSize =
      init.initialBatchSize || this.arrayApp.cardLayout.initialBatchSize;
    this.batchSize = init.batchSize || this.arrayApp.cardLayout.batchSize;
    this.sortBy = init.sortBy || 'recent';
    this.sortOptions = init.sortOptions || [
      ['-followers', i18next.t('Followers')],
      ['recent', i18next.t('Recent')],
      ['name', i18next.t('Name')],
    ];
    this.filterBy = init.filterBy || [];
    this.contains = init.contains || '';
    this.whitelabels = init.whitelabels || [];
    this.variables = new Variables({
      sortBy: () => this.sortBy,
      batchSize: () => {
        if (this.loadedMore) {
          return this.batchSize;
        }
        return this.initialBatchSize;
      },
      cursor: () => this.endCursor,
      filterBy: () => this.filterBy,
      contains: () => this.contains,
      whitelabels: () => this.whitelabels,
    });
    this.loadMoreQuery = init.loadMoreQuery || InitiativesQuery;
  }

  @action
  NewUsername() {
    this.Reset();
  }

  @action
  SetSort(sort) {
    this.sortBy = sort;
    this.Clear();
    this.loadMore();
  }
}
